import axios from 'axios'
import { LISTAR_FILTROS_ROTA } from '../types'
import { URL } from '../../util/ambienteActions';

export default function listarFiltrosRota (idEmpresa) {
  const url = `${URL}/rota/empresa/${idEmpresa}/filtros`
  
  return dispatch => axios.get(url).then(
      response => dispatch({
        type: LISTAR_FILTROS_ROTA,
        payload: response

      })
  );
}
